module.exports = __webpack_public_path__ + "static/media/img_ellipse_306.fd842fc8.webp";